
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseFormWidgetComponent } from '../../../../shared/base-form.component';

@Component({
    selector: 'radio-btn',
    template: `
<div [class]="'radio-button ' + (klass ? ' ' + klass : '') + (disabled ? ' disable' : '')" widget>
    <div class="box" [class.on]="model" (touchrelease)="select()">
        <div class="toggle" [class.on]="model"></div>
    </div>
    <div class="label" (touchrelease)="select()">{{ label }}</div>
</div>`,
    styles: [`.radio-button{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:.5em}.radio-button.disable{opacity:.2;pointer-events:none}.box{position:relative;border:2px solid #009688;height:14px;width:14px;min-width:14px;margin:.2em;border-radius:100%;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.box:hover{background-color:#f2f2f2}.toggle.on{background-color:#009688}.toggle.on:hover{opacity:.8}.toggle{height:6px;width:6px;border-radius:100%}.label{cursor:pointer;margin:0 .25em}`],
})
export class RadioButtonComponent extends BaseFormWidgetComponent<boolean> {
    @Input() public label = '';

    public select() {
        this.model = true;
        this.modelChange.emit(true);
    }
}
